module.exports = __webpack_public_path__ + "static/media/e12.80583bb1.jpg";